<template>
	<div class="search">
		<div class="search-wrapper">
			<div class="input-field">
				<input type="text" class="input" v-model="search" placeholder="Nom ou adresse de l'école ou crèche..."/>
				<div class="icon search-icon" v-if="search.length === 0">
					<search-icon/>
				</div>
				<div class="icon close-icon" v-if="search.length" @click="unsearch()">
					<close-icon/>
				</div>
			</div>

			<div class="results" v-if="results.length">
				<ul>
					<li v-for="r in results" v-bind:key="r.obj.slug">
						<router-link :to=" '/' + r.obj.slug ">
							<span class="nom">{{ r.obj.nom }}</span>
							<span class="adresse">{{ r.obj.adresse }} {{ r.obj.cp }} {{ r.obj.ville }}</span>
						</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import debounce from 'lodash/debounce';
import villeData from "@ville/data";
import etablissements from "@ville/places"
//import {filter} from "fuzzaldrin"; // pas très fin
const fuzzysort = require('fuzzysort');
import SearchIcon from './icons/search.svg';
import CloseIcon from './icons/croix-fermer.svg';

import diacritics from 'diacritics';

export default {
	name: 'SearchControl',
	components: {
		SearchIcon,
		CloseIcon,
	},
	watch: {
		"$route": function(n, o) {
			this.results = [];
		},
		search: function(n, o) {
			const s = diacritics.remove(n).toLowerCase()

			if (n !== this.currentEtablissement) {
				this.$emit('search', s);
				this.query(s);
			}
		}
	},
	data() {
		return {
			search: "",
			etablissements: [],
			results: [],
			currentEtablissement: "",
		};
	},
	created() {
		// pour FuzzySort, on place tous les établissements dans un tableau
		for (let i in etablissements) {
			this.etablissements.push(etablissements[i])
		}

		this.$store.watch(
			(state) => this.$store.getters.etablissement,
			(e) => {

				if (e.slug) {
					this.search = e.nom
					this.currentEtablissement = e.nom
				}
			}
		);



	},
	methods: {
		unsearch() {
			this.search = "";
			this.results = [];
		},
		query: function(s) {
			this.results = [];
			if (s && s.length) {
				let vm = this;
				s = s.toLowerCase();

				let r = fuzzysort.go(s, this.etablissements, {key: "normalized"});

				r = r.slice(0, 20);

				this.results = r;
			}
		},
	},
}
</script>


<style scoped lang="scss">

$placeholder-color: #969696;
$input-color: #000000;

.search {
	width: 100%;
	padding-left: 1rem;
	padding-right: 1rem;
	@include from($tablet) {
		padding-left: 0;
		padding-right: 0;
	}
}

.search-wrapper {

	@include base-box() {
		width: 100%;
		background-color: #fff;
		max-width: 324px;
		margin: 0 auto;

		@include from($tablet) {
			max-width: 400px;
		}

		@include from($desktop) {
			max-width: 500px;
		}
	}
}


.input-field {
	display: flex;
	padding: 2px 8px 2px 7px;
	justify-content: stretch;
	align-items: center;
	/*box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.36);*/
}

input {
	flex-grow: 1;
	border: none !important;
	padding:0;
	outline: none;
	box-shadow: none !important;
	color: $input-color;
	font-family: "Roboto", sans-serif;
	font-weight: 300;
	font-size: 16px;

	&:focus,
	&:hover,
	&:active {
		border: none !important;
		box-shadow: none !important;
	}



	&::-webkit-input-placeholder { /* WebKit, Blink, Edge */
		color:    $placeholder-color;
		opacity:  1;
	}
	&:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
		color:    $placeholder-color;
		opacity:  1;
	}
	&::-moz-placeholder { /* Mozilla Firefox 19+ */
		color:    $placeholder-color;
		opacity:  1;
	}
	&:-ms-input-placeholder { /* Internet Explorer 10-11 */
		color:    $placeholder-color;
		opacity:  1;
	}
	&::-ms-input-placeholder { /* Microsoft Edge */
		color:    $placeholder-color;
		opacity:  1;
	}

	&::placeholder { /* Most modern browsers support this now. */
		color:    $placeholder-color;
		opacity:  1;
	}


}

.results {
	max-height:60vh;
	overflow: auto;

	li {
		border-top: 1px solid #ccc;
		padding: 6px 10px;
		cursor: pointer;

		a {
			color: inherit;

			> * {
				display: block;
			}
		}
		.nom {
			font-weight: bold;
			font-size: .8rem;
		}

		.adresse {
			font-style: italic;
			font-size: .7rem;
		}
	}
}

.icon {
	width: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fff;

	> * {
		fill: $placeholder-color;
		transform-origin: 50%;
		//transform: scale(.8);
	}

}

.close-icon {
	transform: scale(.6);
}

.search-icon {
	cursor: pointer;
	transform: scale(1.24);
}
</style>
